module.exports = __webpack_public_path__ + "media/images/icon-users-a77bb905f46a08c7e04ec2b8db74cac9.svg";